<template>
  <div class="xes-material-filter" :class="{'padding-left': isNeedKnowledge}">
    <div class="knowledge-tree" v-if="isNeedKnowledge">
      <button class="tree-btn" @click="clickTree">知识树</button>
    </div>
    <div class="xes-material-filter-row">
      <!-- 搜索框 -->
      <el-input
        placeholder="请输入内容"
        v-model="filterData.searchValue"
        class="xes-lookfor"
        @keydown.native.13="filterChange('search_word')"
      >
        <el-select v-model="filterData.searchType" slot="prepend" placeholder="请选择">
          <el-option
            v-for="item in filterList.searchType"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click.native="filterChange('search_word')"></el-button>
      </el-input>
    </div>
    <div class="xes-material-filter-row selects">
      <!-- 学部 -->
      <el-select
        v-model="filterData.divisionId"
        @change="filterChange('division_id')"
        placeholder="请选择学部"
        clearable
        v-if="!hides.division"
        :disabled="disableds.division"
      >
        <el-option
          v-for="item in filterList.division"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
      <!-- 学科 -->
      <el-select
        v-model="filterData.subjectId"
        @change="filterChange('subject_id')"
        placeholder="请选择学科"
        clearable
        v-if="!hides.subject"
        :disabled="disableds.subject"
      >
        <el-option v-for="item in subjectList" :label="item.name" :value="item.id" :key="item.id"></el-option>
      </el-select>
      <!-- 年级 -->
      <el-select
        v-model="filterData.gradeId"
        @change="filterChange('grade_id')"
        placeholder="请选择年级"
        clearable
        v-if="!hides.grade"
        :disabled="disableds.grade"
      >
        <el-option v-for="item in gradeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
      </el-select>
      <!-- 版本 -->
      <el-select
        v-model="filterData.versionId"
        @change="filterChange('version_id')"
        placeholder="请选择版本"
        clearable
        v-if="!hides.version"
        :disabled="disableds.version"
      >
        <el-option
          v-for="item in filterList.version"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
      <!-- 状态 -->
      <el-select
        v-model="filterData.status"
        @change="filterChange('status_id')"
        placeholder="是否审核"
        clearable
        v-if="!hides.status"
        :disabled="disableds.status"
      >
        <el-option
          v-for="item in filterList.status"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
      <!-- 知识类型 -->
      <el-select
        v-model="filterData.type"
        @change="filterChange('type')"
        placeholder="请选择知识类型"
        clearable
        v-if="!hides.type"
        :disabled="disableds.type"
      >
        <el-option
          v-for="item in filterList.type"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
      <!-- 进度 -->
      <el-select
        v-model="filterData.schedule"
        @change="filterChange('schedule')"
        placeholder="请选择进度"
        clearable
        v-if="!hides.schedule"
        :disabled="disableds.schedule"
      >
        <el-option
          v-for="item in filterList.schedule"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
      <!-- 语音测评 -->
      <el-select
        v-model="filterData.speech"
        @change="filterChange('speech')"
        placeholder="请选择语音测评"
        clearable
        v-if="!hides.speech"
        :disabled="disableds.speech"
      >
        <el-option
          v-for="item in filterList.speech"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
      <!-- 素材类型 -->
      <el-select
        v-model="filterData.materialType"
        @change="filterChange('materialType')"
        placeholder="请选择素材类型"
        clearable
        v-if="!hides.materialType"
        :disabled="disableds.materialType"
      >
        <el-option
          v-for="item in materialTypeOptions"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
    </div>

    <div class="clearfix">
      <!-- 清空 -->
      <span class="xes-filter-clear" @click="clearClick">清空筛选</span>
    </div>
  </div>
</template>

<script>
import { httpRequest } from 'xes-frontend-ui/src/utils/ajax'
export default {
  name: 'xes-material-filter',
  props: {
    defaults: {// 默认值
      type: Object,
      default () {
        return {}
      }
    },
    disableds: {// 锁定项
      type: Object,
      default () {
        return {}
      }
    },
    hides: { // 隐藏项
      type: Object,
      default () {
        return {}
      }
    },
    token: {
      type: String,
      required: true
    },
    action: { // 请求接口url
      type: String,
      required: true
    },
    params: { // 自定义请求参数
      type: Object,
      default () {
        return {}
      }
    },
    headers: { // 自定义请求头
      type: Object,
      default () {
        return {}
      }
    },
    withCredentials: { // 跨域时是否支持发送cookie
      type: Boolean,
      default: false
    },
    isNeedKnowledge: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      filterData: {
        searchValue: '', // 搜索关键词
        searchType: '', // 搜索类型id
        divisionId: '', // 学部id
        subjectId: '', // 学科id
        gradeId: '', // 年级id
        versionId: '', // 版本id
        status: '', // 状态id
        type: '', // 知识类型
        materialType: '', // 素材类型
        schedule: '', // 进度
        speech: '' // 语音测评
      },
      filterList: {// 筛选数据列表
        division: [], // 学部列表
        subject: {}, // 学科列表
        grade: {}, // 年级列表
        version: [], // 版本列表
        status: [], // 状态liebiao
        searchType: [], // 搜索类型列表
        type: [], // 知识类型
        speech: [], // 语音测评
        schedule: [], // 进度
        materialType: {} // 素材类型
      }
    }
  },
  watch: {
    defaults (val) {
      this.setDefaults()
    }
  },
  methods: {
    getFilterList () { // 获取筛选列表
      if (!this.action) {
        throw new Error('getConditions地址为空！')
      }
      const params = Object.assign({}, this.params)
      let options = {
        params,
        headers: Object.assign({}, this.headers, { jytoken: this.token || '' }),
        withCredentials: this.withCredentials,
        action: this.action
      }
      httpRequest(options).then(res => {
        if (res.status == 100) {
          this.filterList = Object.assign({}, this.filterList, {
            division: res.data.division,
            subject: res.data.subject,
            grade: res.data.grade,
            version: res.data.version,
            status: res.data.status,
            searchType: res.data.searchType,
            type: res.data.type,
            speech: res.data.speech,
            schedule: res.data.schedule,
            materialType: res.data.materialType
          })
          this.setDefaults()
          this.$emit('ajax-success', res.data)
        } else {
          this.$emit('status-error', res)
        }
      }).catch(err => {
        this.$emit('catch-ajax-error', err)
      })
    },
    filterChange (type) { // 筛选值改变时方法
      if (type === 'division_id') {
        this.filterData.subjectId = ''
        this.filterData.gradeId = ''
      }
      this.$emit('change', { data: this.filterData, type: type })
    },
    clearClick () {
      this.setDefaults()
      this.$emit('change', { data: this.filterData, type: 'clear' })
    },
    setDefaults () { // 设置默认值
      this.filterData.searchValue = ''
      this.filterData.searchType = typeof this.defaults.searchType !== 'undefined' ? this.defaults.searchType : ''
      this.filterData.divisionId = typeof this.defaults.divisionId !== 'undefined' ? this.defaults.divisionId : ''
      this.filterData.subjectId = typeof this.defaults.subjectId !== 'undefined' ? this.defaults.subjectId : ''
      this.filterData.gradeId = typeof this.defaults.gradeId !== 'undefined' ? this.defaults.gradeId : ''
      this.filterData.versionId = typeof this.defaults.versionId !== 'undefined' ? this.defaults.versionId : ''
      this.filterData.status = typeof this.defaults.status !== 'undefined' ? this.defaults.status : ''
      this.filterData.type = typeof this.defaults.type !== 'undefined' ? this.defaults.type : ''
      this.filterData.speech = typeof this.defaults.speech !== 'undefined' ? this.defaults.speech : ''
      this.filterData.schedule = typeof this.defaults.schedule !== 'undefined' ? this.defaults.schedule : ''
      this.filterData.materialType = typeof this.defaults.materialType !== 'undefined' ? this.defaults.materialType : ''
    },
    // 点击知识树按钮
    clickTree () {
      this.$emit('click-tree')
    }
  },
  computed: {
    subjectList () { // 学科列表联动
      if (!this.filterList.subject) return []
      let list = this.filterList.subject[Number(this.filterData.divisionId)]
      return list
    },
    gradeList () { // 年级列表联动
      if (!this.filterList.grade) return []
      let list = this.filterList.grade[Number(this.filterData.divisionId)]
      return list
    },
    materialTypeOptions () {
      let resultTypes = []
      if (this.filterData.subjectId) {
        resultTypes = this.filterList.materialType[this.filterData.subjectId]
      } else {
        for (const key in this.filterList.materialType) {
          if (this.filterList.materialType.hasOwnProperty(key)) {
            const element = this.filterList.materialType[key]
            resultTypes = Object.assign({}, resultTypes, element)
          }
        }
      }
      return resultTypes
    }
  },
  mounted () {
    this.getFilterList()
  }
}
</script>



// WEBPACK FOOTER //
// packages/material-filter/src/index.vue